export default __webpack_public_path__ + "images/ab5d51a2a44fd94c3ca877537f969d77.svg";